import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center w-full h-full text-2xl font-bold text-white" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, "Logging In", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "w-12 h-12 mt-4 border-2 rounded-full animate-spin loader" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

import { onErrorCaptured, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { getCookie } from 'tiny-cookie';
import { useUserStore } from '@/store/users';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const userStore = useUserStore();

onMounted(async () => {
  const main = window.location.href.split('#')[0];
  const sub = main.split('?')[1];
  const parts = sub.split('&');

  const body: Record<string, string> = {
    r_token: getCookie('twitoken') || '',
  };
  let subparts = parts[0].split('=');
  [, body[subparts[0]]] = subparts;
  subparts = parts[1].split('=');
  [, body[subparts[0]]] = subparts;
  try {
    await userStore.loginTwitterCallback({
      ...body,
    });
    window.history.replaceState({}, document.title, window.location.pathname);
    router.push('/scorecards');
  } catch (error) {
    console.log(error);
    router.push('/login');
  }
});

onErrorCaptured((e) => console.error(e));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}
}

})